import React, { useContext, useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';

import { SearchModalContext } from '../../contexts/searchModalContext';
import { SearchModalStyles } from '../../styles/search/SearchModalStyles';
import ActionButton from '../buttons/ActionButton';
import SearchResult from './SearchResult';
import SearchField from './SearchField';

function Search() {
  const { isSearchModalOpen, closeSearchModal, searchIndexStore } = useContext(SearchModalContext);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (isSearchModalOpen) {
      document.body.style.overflow = 'hidden';
      setSearchQuery('');
    } else {
      document.body.style.overflow = 'unset';
    }

    // FIX: Failsafe cleanup for body overflow
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSearchModalOpen]);

  if (!isSearchModalOpen) return null;

  // Check if data is fully downloaded
  const isLoaded = searchIndexStore && !searchIndexStore.isLoading;

  return (
    <SearchModalStyles>
      <div className="modal__container">
        
        {/* FIX: Keyboard accessibility for close button */}
        <ActionButton 
          className="close" 
          onClick={closeSearchModal}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') closeSearchModal();
          }}
          aria-label="Close Search"
        >
          <MdClose />
        </ActionButton>

        {/* Removed onFocus prop as we no longer fetch on focus */}
        <SearchField
          value={searchQuery}
          setValue={setSearchQuery}
        />

        {searchQuery && isLoaded && (
          <div className="search__result">
            <SearchResult
              searchQuery={searchQuery}
              blogsIndexStore={searchIndexStore.blogs}
              categoriesIndexStore={searchIndexStore.categories}
              authorsIndexStore={searchIndexStore.authors}
              activitiesIndexStore={searchIndexStore.activities}
            />
          </div>
        )}

        {/* Optional: Add a small loading indicator if they type fast before download finishes */}
        {searchQuery && !isLoaded && (
           <div className="search__result">
              <p style={{color: 'var(--gray)', fontSize: '1.4rem'}}>Loading search indexes...</p>
           </div>
        )}

      </div>
    </SearchModalStyles>
  );
}

export default Search;